import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { serverDomain } from "../../../config";
import moment from "moment-timezone";
import "../../../styles/ApprovalsPage.css";

const ApprovalsPage = () => {
  const [users, setUsers] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(`${serverDomain}/api/admin/approvals/pending-users`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers(response.data || []);
    } catch (error) {
      console.error("Ошибка загрузки пользователей", error);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (userId) => {
    try {
      const token = localStorage.getItem("token");
      await axios.put(`${serverDomain}/api/admin/approvals/approve/${userId}`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers((prev) => prev.filter((u) => u.id !== userId));
    } catch (error) {
      console.error("Ошибка при одобрении пользователя", error);
      alert("Ошибка при одобрении");
    }
  };

  const handleReject = async (userId) => {
    const confirmReject = window.confirm("Вы уверены, что хотите отклонить этого пользователя?");
    if (!confirmReject) return;

    try {
      const token = localStorage.getItem("token");
      await axios.delete(`${serverDomain}/api/admin/approvals/reject/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUsers((prev) => prev.filter((u) => u.id !== userId));
    } catch (error) {
      console.error("Ошибка при отклонении пользователя", error);
      alert("Ошибка при отклонении");
    }
  };

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return users;

    return users.filter((u) => {
      const hay = [
        u.id,
        u.name,
        u.email,
        u.telegram,
        u.hear_about_us,
        u.traffic_source,
        u.average_daily,
      ]
        .map((x) => (x == null ? "" : String(x).toLowerCase()))
        .join(" ");
      return hay.includes(s);
    });
  }, [users, q]);

  return (
    <div className="fl-adminpage fl-approvals">
      <div className="fl-adminpage__head">
        <h2 className="fl-h2">Анкеты на одобрение</h2>
        <div className="fl-adminpage__meta">
          Всего: <b>{filtered.length}</b>
        </div>
      </div>

      <div className="fl-toolbar fl-approvals__toolbar">
        <input
          className="fl-input fl-input--wide"
          placeholder="Поиск: id / email / tg / источник…"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />

        <button className="fl-btn fl-btn--ghost" type="button" onClick={fetchUsers} disabled={loading}>
          {loading ? "Загрузка…" : "Обновить"}
        </button>
      </div>

      {filtered.length === 0 ? (
        <div className="fl-empty">{loading ? "Загрузка…" : "Нет анкет на одобрение"}</div>
      ) : (
        <div className="fl-table-wrap">
          <table className="fl-table fl-approvals__table">
            <thead>
              <tr>
                <th className="col-id">ID</th>
                <th className="col-name">Имя</th>
                <th className="col-email">Email</th>
                <th className="col-tg">Telegram</th>
                <th className="col-hear">Откуда узнали?</th>
                <th className="col-source">Источники трафика</th>
                <th className="col-volume">Объёмы/день</th>
                <th className="col-created">Создано</th>
                <th className="col-actions">Действия</th>
              </tr>
            </thead>

            <tbody>
              {filtered.map((u) => (
                <tr key={u.id}>
                  <td className="col-id">{u.id}</td>
                  <td className="col-name">{u.name}</td>
                  <td className="col-email">{u.email}</td>
                  <td className="col-tg">{u.telegram || "—"}</td>
                  <td className="col-hear">{u.hear_about_us || "—"}</td>
                  <td className="col-source">{u.traffic_source || "—"}</td>
                  <td className="col-volume">{u.average_daily || "—"}</td>
                  <td className="col-created">{moment(u.created_at).format("DD.MM.YYYY HH:mm")}</td>
                  <td className="col-actions">
                    <div className="fl-approvals__actions">
                      <button className="fl-btn fl-btn--mini" type="button" onClick={() => handleApprove(u.id)}>
                        ✅ Одобрить
                      </button>
                      <button className="fl-btn fl-btn--mini fl-btn--danger" type="button" onClick={() => handleReject(u.id)}>
                        ❌ Отклонить
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ApprovalsPage;